// extracted by mini-css-extract-plugin
export default {"Related_Image":"Related_Related_Image__J1412","heading_style":"Related_heading_style__ihcXK"};